/* Joii Employee Benefits claim: choose your employee benefits provider, then Add to basket lights up.
   - Two copies (in the header and in the floating bar) share one choice.
   - Choosing a provider: the button's full price is struck through and swapped for the discounted
     price, the button turns black with a pop and a light racing round its edge, and the bar's title
     becomes "30% [partner] discount applied". "None" keeps Add to basket disabled.
   - Each provider can add its own product (so orders are attributed by product); the choice is also
     sent with the order as the hidden note "_Partner".
   - Add to basket before choosing: the dropdown turns red with a message and a small shake.
   - ?partner=pluxee (or a code from the hero's Partner codes list) locks the page to that provider: no dropdown,
     their product ready to add, like a partner page.
   - Partner pages have no dropdown: the partner and product are fixed and the button is ready.
   - The floating bar slides in once the header copy has scrolled away, and tucks away at the footer. */
(function () {
  function norm(v) { return String(v || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var roots = Array.prototype.slice.call(document.querySelectorAll('[data-jb-claim]'));
    if (!roots.length) return;
    var cfg = {};
    try { cfg = JSON.parse((document.getElementById('jb-claim-config') || {}).textContent || '{}'); } catch (e) {}
    var fixed = roots[0].getAttribute('data-jb-fixed');
    var choice = fixed || '';

    function each(sel, fn) { roots.forEach(function (r) { Array.prototype.forEach.call(r.querySelectorAll(sel), fn); }); }

    function closeAll(except) {
      each('[data-jb-dd]', function (dd) {
        if (dd === except) return;
        dd.classList.remove('is-open');
        dd.querySelector('.jb-dd__button').setAttribute('aria-expanded', 'false');
        dd.querySelector('.jb-dd__list').hidden = true;
      });
    }

    // errors show in the field's own label (red border + small shake)
    function setError(on, msg) {
      msg = msg || cfg.msgChoose || '';
      each('[data-jb-dd]', function (dd) {
        var label = dd.querySelector('.jb-dd__label');
        if (!label.hasAttribute('data-text')) label.setAttribute('data-text', label.textContent);
        dd.classList.toggle('is-error', on);
        label.textContent = on ? msg : label.getAttribute('data-text');
        if (on) { dd.classList.remove('is-shake'); void dd.offsetWidth; dd.classList.add('is-shake'); }
      });
      each('[data-jb-msg]', function (m) { m.textContent = on ? msg : ''; });
    }

    // apply a choice to every copy; animate = the delightful bit
    var noneChosen = false;
    function choose(value, animate) {
      var wasWaiting = !choice;
      var opt = roots[0].querySelector('[role="option"][data-value="' + (window.CSS && CSS.escape ? CSS.escape(value) : value) + '"]');
      var isNone = !!(opt && opt.hasAttribute('data-none'));
      var prevNone = noneChosen;
      noneChosen = isNone;
      choice = value;
      setError(false);
      each('[data-jb-dd]', function (dd) {
        dd.classList.add('is-filled');
        var input = dd.querySelector('[data-jb-dd-input]');
        if (input) input.value = value;
      });
      each('[data-jb-provider-input]', function (i) { i.value = isNone ? '' : value; });
      // each provider can add its own product (attribution by product)
      var optVariant = opt && opt.getAttribute('data-variant');
      var optPrice = opt && opt.getAttribute('data-price');
      each('[data-jb-variant]', function (i) {
        i.value = optVariant || i.getAttribute('data-discount');
      });
      if (optPrice) each('[data-jb-now]', function (el) { el.textContent = optPrice; });
      each('[data-jb-title]', function (t) {
        var next = isNone ? t.getAttribute('data-default') : (t.getAttribute('data-applied') || '').replace('[partner]', value);
        if (t.textContent === next) return;
        if (animate && !reduced) {
          t.classList.add('is-swapping');
          setTimeout(function () { t.textContent = next; t.classList.remove('is-swapping'); }, 220);
        } else { t.textContent = next; }
      });
      roots.forEach(function (r) {
        r.classList.toggle('is-discounted', !isNone);
        var btn = r.querySelector('.jb-claim__add');
        if (!btn) return;
        // "None": no benefits provider, so nothing to add
        btn.classList.toggle('is-waiting', isNone);
        btn.disabled = isNone;
        if (isNone) return;
        if (animate && (wasWaiting || prevNone !== isNone)) {
          // a green "✓ Discount applied" for a moment, then Add to basket with the light running round its edge
          btn.classList.remove('is-enabling'); btn.classList.add('is-confirming');
          clearTimeout(btn._jbConfirm);
          btn._jbConfirm = setTimeout(function () {
            btn.classList.remove('is-confirming');
            if (reduced) return;
            void btn.offsetWidth; btn.classList.add('is-enabling');
            setTimeout(function () { btn.classList.remove('is-enabling'); }, 2600);
          }, 1100);
        }
      });
    }

    // Type-to-apply: no visible list. "Apply discount" checks the text against the providers
    // (capitals, spaces and punctuation ignored; the start of a name or a small typo is fine).
    function canon(v) { return norm(v); }
    function lev(a, b) { // edit distance, for small typos
      var d = [], i, j;
      for (i = 0; i <= a.length; i++) d[i] = [i];
      for (j = 0; j <= b.length; j++) d[0][j] = j;
      for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++)
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      return d[a.length][b.length];
    }
    function providerOptions() { return Array.prototype.slice.call(roots[0].querySelectorAll('[role="option"]')); }
    function findMatch(text) {
      var t = canon(text);
      if (t.length < 2) return null;
      var opts = providerOptions(), names = opts.map(function (o) { return o.getAttribute('data-value'); });
      var exact = opts.filter(function (o, i) { return canon(names[i]) === t; });
      if (exact.length) return exact[0];
      if (t.length >= 3) {
        // the start of the name, or of any word in it ("tokio", "marine", "sains")
        var starts = opts.filter(function (o, i) {
          return canon(names[i]).indexOf(t) === 0 || names[i].split(/\s+/).some(function (w) { return canon(w).length >= 3 && canon(w).indexOf(t) === 0; });
        });
        if (starts.length === 1) return starts[0];
      }
      if (t.length >= 5) {
        // a small typo in the full name ("sainsburry", "tokyo marine")
        var close = opts.filter(function (o, i) { var n = canon(names[i]); return lev(t, n) <= (n.length >= 8 ? 2 : 1); });
        if (close.length === 1) return close[0];
      }
      return null;
    }
    function clearChoice() {
      if (!choice) return;
      choice = ''; noneChosen = false;
      each('[data-jb-provider-input]', function (i) { i.value = ''; });
      each('[data-jb-variant]', function (i) { i.value = i.getAttribute('data-discount'); });
      each('[data-jb-title]', function (t) { t.textContent = t.getAttribute('data-default'); });
      roots.forEach(function (r) {
        r.classList.remove('is-discounted');
        var btn = r.querySelector('.jb-claim__add');
        if (btn) { btn.disabled = false; btn.classList.remove('is-enabling', 'is-confirming'); clearTimeout(btn._jbConfirm); }
      });
    }
    function syncButtons() {
      var typed = '';
      each('[data-jb-dd-input]', function (i) { if (i.value.trim()) typed = i.value; });
      roots.forEach(function (r) {
        var btn = r.querySelector('.jb-claim__add');
        if (btn && !choice) btn.classList.toggle('is-waiting', !typed.trim());
      });
    }
    function apply(fromInput) {
      var match = findMatch(fromInput.value);
      if (match) { choose(match.getAttribute('data-value'), true); each('[data-jb-dd]', updateGhost); return true; }
      setError(true, fromInput.value.trim() ? (cfg.msgNotFound || '') : (cfg.msgChoose || ''));
      fromInput.focus();
      return false;
    }
    // Type-ahead: after 3+ letters, if exactly ONE provider name starts with what's typed, show the rest in grey.
    function suggestion(text) {
      var raw = String(text || '');
      if (canon(raw).length < 3) return null;
      var low = raw.toLowerCase();
      var hits = providerOptions().map(function (o) { return o.getAttribute('data-value'); })
        .filter(function (n) { return n.toLowerCase().indexOf(low) === 0 && n.length > raw.length; });
      return hits.length === 1 ? hits[0] : null;
    }
    function updateGhost(dd) {
      var input = dd.querySelector('[data-jb-dd-input]'), ghost = dd.querySelector('.jb-dd__ghost');
      if (!input || !ghost) return;
      var s = choice ? null : suggestion(input.value);
      ghost.querySelector('.jb-dd__ghost-typed').textContent = s ? input.value : '';
      ghost.querySelector('.jb-dd__ghost-rest').textContent = s ? s.slice(input.value.length) : '';
      dd.classList.toggle('has-ghost', !!s);
    }
    function acceptGhost(input) {
      var s = suggestion(input.value);
      if (!s) return false;
      each('[data-jb-dd-input]', function (o) { o.value = s; o.closest('[data-jb-dd]').classList.add('is-filled'); });
      each('[data-jb-dd]', updateGhost);
      syncButtons();
      return true;
    }
    each('[data-jb-dd]', function (dd) {
      var input = dd.querySelector('[data-jb-dd-input]');
      if (!input) return;
      input.addEventListener('input', function () {
        // keep the header field and the floating bar's field in step
        each('[data-jb-dd-input]', function (o) {
          if (o !== input) o.value = input.value;
          o.closest('[data-jb-dd]').classList.toggle('is-filled', !!input.value.trim());
        });
        if (dd.classList.contains('is-error')) setError(false);
        if (choice && canon(input.value) !== canon(choice)) clearChoice();
        syncButtons();
        each('[data-jb-dd]', updateGhost);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); if (!choice) apply(input); return; }
        // Tab or → (with the cursor at the end) accepts the grey suggestion
        var atEnd = input.selectionStart === input.value.length && input.selectionEnd === input.value.length;
        if ((e.key === 'Tab' && !e.shiftKey || e.key === 'ArrowRight') && atEnd && dd.classList.contains('has-ghost')) {
          if (acceptGhost(input)) e.preventDefault();
        }
      });
      input.addEventListener('blur', function () { dd.classList.remove('has-ghost'); });
      input.addEventListener('focus', function () { updateGhost(dd); });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-jb-dd]')) closeAll(); });

    // Add to basket before choosing
    each('.jb-claim__form', function (form) {
      form.noValidate = true;
      form.addEventListener('submit', function (e) {
        if (fixed) return;
        if (!choice || noneChosen) {
          e.preventDefault();
          var input = form.querySelector('[data-jb-dd-input]');
          if (input) apply(input);
        }
      });
    });

    // pre-select from a ?partner= link
    var preset = '';
    var code = new URLSearchParams(window.location.search).get('partner');
    var wanted = preset ? [preset] : (code ? [code] : []);
    if (!preset && code) {
      try {
        var map = JSON.parse((document.getElementById('jb-partners') || {}).textContent || '{}');
        if (map[code.toLowerCase()]) wanted.unshift(map[code.toLowerCase()]);
      } catch (e) {}
    }
    if (wanted.length && !fixed) {
      var first = roots[0].querySelector('[data-jb-dd]');
      var match = first && Array.prototype.find.call(first.querySelectorAll('[role="option"]'), function (o) {
        return wanted.some(function (w) { return norm(w) === norm(o.getAttribute('data-value')); });
      });
      if (match && !match.hasAttribute('data-none')) {
        // arrived from a partner link: behave like that partner's own page — no dropdown, their product ready to add
        choose(match.getAttribute('data-value'), false);
        fixed = match.getAttribute('data-value');
        each('[data-jb-dd]', function (dd) { dd.style.display = 'none'; });
        roots.forEach(function (r) { r.classList.add('is-locked'); });
      }
    }

    // Floating bar: lives at the end of the page (so nothing covers it), appears once the header copy has
    // scrolled away, and tucks away at the footer.
    var bar = document.querySelector('[data-jb-float]');
    if (!bar) return;
    if (bar.parentNode !== document.body) {
      Array.prototype.forEach.call(document.querySelectorAll('body > [data-jb-float]'), function (old) { if (old !== bar) old.remove(); });
      document.body.appendChild(bar);
    }
    var heroClaim = document.querySelector('[data-jb-claim-hero]');
    var footer = document.querySelector('footer, .shopify-section-group-footer-group');
    var heroGone = !heroClaim, footerIn = false;
    // The theme (and apps like the cookie/privacy shield) put small fixed buttons in the bottom corners.
    // While the bar shows, they're lifted just above it, and on desktop/tablet the bar's edges line up with theirs.
    var barShown = false, lifted = [];
    function allElements() {
      var all = [];
      (function walk(root) {
        Array.prototype.forEach.call(root.querySelectorAll('*'), function (el) {
          all.push(el);
          if (el.shadowRoot) walk(el.shadowRoot);
        });
      })(document.body);
      return all;
    }
    function visibleBox(el) {
      var cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return null;
      var r = el.getBoundingClientRect();
      return r.width && r.height ? r : null;
    }
    // small fixed things near the bottom edge; for thin full-width strips, the small visible bits inside them
    function cornerWidgets() {
      var vw = window.innerWidth, vh = window.innerHeight, all = allElements(), found = [];
      all.forEach(function (el) {
        if (el === bar || bar.contains(el) || el.contains(bar)) return;
        if (getComputedStyle(el).position !== 'fixed') return;
        var r = visibleBox(el);
        if (!r || r.height > vh * 0.4 || vh - r.bottom > 140) return;
        if (r.width < vw * 0.4) { found.push({ el: el, r: r }); return; }
        // a strip: use its small visible children (incl. inside an app's shadow root)
        var kids = [];
        (function walk(root) {
          Array.prototype.forEach.call(root.querySelectorAll('*'), function (k) {
            if (k.shadowRoot) walk(k.shadowRoot);
            var kr = visibleBox(k);
            if (kr && kr.width < vw * 0.4 && kr.width > 12 && vh - kr.bottom < 140) kids.push({ el: el, r: kr });
          });
        })(el);
        found = found.concat(kids);
      });
      return found;
    }
    var isPhone = function () { return window.innerWidth < 750; };
    function fitBar() {
      // reset first so we measure the widgets in their own positions (no animation, or we'd measure them mid-slide)
      lifted.forEach(function (el) { if (barShown) el.style.transition = 'none'; el.style.translate = ''; });
      if (lifted.length) void document.body.offsetHeight;
      var wasLifted = lifted;
      lifted = [];
      bar.style.left = ''; bar.style.right = '';
      if (!barShown) return; // (hiding: the widgets glide back down with their transition)
      var vw = document.documentElement.clientWidth, ws = cornerWidgets(); // clientWidth: fixed 'right' ignores the scrollbar
      if (!ws.length) return;
      // desktop/tablet: the bar spans exactly from the outer edge of the left widget to the outer edge of the right one
      if (!isPhone()) {
        // same gap on both sides (so the bar stays centred), matching the corner widget nearest the edge
        var inset = parseFloat(getComputedStyle(bar).left) || 40;
        ws.forEach(function (w) {
          var fromEdge = (w.r.left + w.r.width / 2 < vw / 2) ? w.r.left : vw - w.r.right;
          inset = Math.min(inset, fromEdge);
        });
        inset = Math.max(0, Math.round(inset));
        bar.style.left = inset + 'px';
        bar.style.right = inset + 'px';
      }
      // then lift each widget so its bottom sits exactly 16px above the bar's top edge (measured where the bar really is)
      // the bar may still be sliding in, so work out where it ends up rather than where it is mid-animation
      var barTop = window.innerHeight - (parseFloat(getComputedStyle(bar).bottom) || 0) - bar.offsetHeight;
      var byEl = new Map();
      ws.forEach(function (w) { byEl.set(w.el, Math.max(byEl.get(w.el) || 0, w.r.bottom)); });
      byEl.forEach(function (bottom, el) {
        var lift = Math.max(0, Math.round(bottom - (barTop - 16)));
        if (!lift) return;
        lifted.push(el);
        el.style.translate = '0 -' + lift + 'px';
      });
      // animate from here on (next frame, so the reset above isn't animated)
      requestAnimationFrame(function () {
        lifted.concat(wasLifted).forEach(function (el) { el.style.transition = 'translate 250ms ease'; });
      });
    }
    // re-check when widgets appear later (e.g. the theme's back-to-top arrow fades in once you've scrolled),
    // when anything is added or shown, on resize, and once scrolling stops
    var fitTimer, fitting = false;
    function refitSoon(ms) { if (!barShown) return; clearTimeout(fitTimer); fitTimer = setTimeout(function () { fitting = true; fitBar(); setTimeout(function () { fitting = false; }, 50); }, ms); }
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        if (fitting) return; // ignore our own style changes
        if (muts.every(function (m) { return m.target === bar || bar.contains(m.target) || lifted.indexOf(m.target) !== -1; })) return;
        refitSoon(250);
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    }
    window.addEventListener('resize', function () { refitSoon(150); });
    window.addEventListener('scroll', function () { refitSoon(300); }, { passive: true });

    function update() {
      var show = heroGone && !footerIn;
      bar.classList.toggle('is-hidden', !show);
      if (!show) closeAll();
      if (show !== barShown) { barShown = show; fitting = true; fitBar(); setTimeout(function () { fitting = false; }, 50); }
    }
    update();
    if (!('IntersectionObserver' in window)) return;
    if (heroClaim) new IntersectionObserver(function (en) { heroGone = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; update(); }).observe(heroClaim);
    if (footer) new IntersectionObserver(function (en) { footerIn = en[0].isIntersecting; update(); }).observe(footer);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
